import { GridColDef } from '@mui/x-data-grid';
import { IntlShape } from 'react-intl';
import { TeamMemberRow } from '../../entity';
import { SkillUpdateInput } from '../../queries';
import DeleteCell from './DeleteCell';
import StockAccessCheckboxCell from './StockAccessCheckboxCell';

export const createTeamColumns = (
  allRows: TeamMemberRow[],
  onUpdateSkill: (data: SkillUpdateInput) => void,
  onDelete: (userId: string) => void,
  intl: IntlShape,
): GridColDef<TeamMemberRow[][number]>[] => [
  {
    field: 'name',
    headerName: `${intl.formatMessage({ id: 'team.user', defaultMessage: 'Uživatel' })}`,
    flex: 6,
    minWidth: 110,
    disableColumnMenu: true,
  },
  {
    field: 'canAccessStocks',
    headerName: `${intl.formatMessage({ id: 'team.stock', defaultMessage: 'Sklad' })}`,
    flex: 6,
    width: 85,
    disableColumnMenu: true,
    renderCell: params => (
      <StockAccessCheckboxCell
        checked={params.value}
        row={params.row}
        allRows={allRows}
        onUpdate={onUpdateSkill}
      />
    ),
  },
  {
    field: 'delete',
    headerName: '',
    width: 60,
    disableColumnMenu: true,
    renderCell: params => <DeleteCell row={params.row} allRows={allRows} onDelete={onDelete} />,
  },
];
